package com.example.mystybag.core.expected

import com.example.mystybag.commonData.expected.isInRelease
import com.example.mystybag.core.expected.LogHelper.logExceptionEvent
import com.example.mystybag.core.helpers.globalExceptionHandler
import kotlinx.coroutines.CoroutineName
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import kotlinx.coroutines.plus

expect object LogHelper {
    fun logExceptionEvent(e: Exception)
    fun setCrashlyticsUserId(userId: String)
    fun logEvent(message: String)
    /** Firebase Analytics (Android); no-op on other platforms until wired. */
    fun logAnalyticsEvent(eventName: String, parameters: Map<String, String> = emptyMap())
}

fun logException(e: Exception) {
    if (isInRelease())
        (CoroutineScope(CoreDispatchers.default) + globalExceptionHandler).launch(CoroutineName("logException")) {
            logExceptionEvent(e)
        }
}
